import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../component/Footer";
import SellerNavbar from "../component/SellerNavbar";
import axios from "axios";
import { baseurl } from "../Baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CustomerResetPassword = () => {
  const { token } = useParams(); // get reset token from route param
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
  
    if (!password || !confirmPassword) {
      toast.error("Please fill in all fields.");
      return;
    }
  
    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }
  
    try {
      setLoading(true);
  
      const payload = {
        reset_token: token,
        password,
        confirm_password: confirmPassword,
      };
  
      console.log("Sending data:", payload);
  
      const response = await axios.post(`${baseurl}resetPasswordCustomer`, payload);
  
      console.log("Response received:", response.data);
  
      const { success, message } = response.data;
  
      if (success) {
        toast.success(message || "Password reset successful!");
        setTimeout(() => {
          navigate("/");
        }, 1500);
      } else {
        toast.error(message || "Failed to reset password.");
      }
  
    } catch (error) {
      console.error("Error resetting password:", error.response || error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  
  

  return (
    <>
      <SellerNavbar />
      <section className="mb-5">
        <div className="container-fluid">
          <div className="row my-3 justify-content-center">
            <div className="col-md-5">
              <div className="reviewcls">
                <h4 className="review-form-heading">Reset Your Password</h4>
                <hr />
                <form onSubmit={handleResetPassword} className="contact-form text-center">
                  <div className="form-group mb-3">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="New Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group mb-3">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Confirm New Password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                  </div>
                  <button type="submit" className="btn submitbtnn w-100" disabled={loading}>
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>{" "}
                        Submitting...
                      </>
                    ) : (
                      "Reset Password"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default CustomerResetPassword;
